import { render, staticRenderFns } from "./ProductApproveDialog.vue?vue&type=template&id=7fd13ce9&scoped=true"
import script from "./ProductApproveDialog.vue?vue&type=script&lang=js"
export * from "./ProductApproveDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductApproveDialog.vue?vue&type=style&index=0&id=7fd13ce9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd13ce9",
  null
  
)

export default component.exports